import { PermissionsModule } from './permissions/permissions.module';
import { GroupsModule } from './groups/groups.module';
import { ExchangeRateModule } from './exchange-rate/exchange-rate.module';
import { CurrencyModule } from './currency/currency.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { SkuPriceModule } from './sku-price/sku-price.module';
import {ApiAccessTokenModule} from './crm-token/crm-token.module';
import {IntegrationsModule} from './integrations/integrations.module';

const routes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      {
        path: '',
        redirectTo: 'currency',
        pathMatch: 'full',
      },
      { path: 'currency', loadChildren: () => CurrencyModule },
      { path: 'exchange_rate', loadChildren: () => ExchangeRateModule },
      { path: 'groups', loadChildren: () => GroupsModule },
      { path: 'permissions', loadChildren: () => PermissionsModule },
      { path: 'sku-pricing', loadChildren: () => SkuPriceModule },
      { path: 'api-access-token', loadChildren: () => ApiAccessTokenModule },
      { path: 'integrations', loadChildren: () => IntegrationsModule },

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
